export default [
  '$window',
  'CustomerService', 'UserDataService', 'CartService',
  class PaymentMethodsCtrl {
    constructor($window, customerService, userData, cartService) {
      this._$window = $window;
      this._customerService = customerService;
      this._userData = userData;
      this.cart = cartService;

      this.monthRange = [];
      this.yearRange = [];
      this.popoverPath = 'assets/customer-ui/templates/cvv-help.html';

      this._initCardData();
      this._initSelectOptions();
    }

    save(valid) {
      if (valid) {
        var newCCToken;

        this.loading = true;
        this.cart.createCCTokenCart(this.card, this.currentUser.user_info.shipping_details)
          .then(res => {
            newCCToken = res.token;
            if (this.savedCard.id) {
              return this._customerService.removeSavedPaymentMethod(this.currentUser.user_info.public_name, this.savedCard.id);
            }
          })
          .then(() => this._customerService.updateSavedPaymentMethod(this.currentUser.user_info.public_name, newCCToken, this._cardLast4(), this._cardBin()))
          .then(() => this._initCardData())
          .finally(() => {
            this.loading = false;
          });
      }
    }

    delete() {
      let confirm = this._$window.confirm('Are you sure you want to delete this card?');
      if (!confirm) return;

      this.loading = true;
      this._customerService.removeSavedPaymentMethod(this.currentUser.user_info.public_name, this.savedCard.id)
        .then(() => this._initCardData())
        .finally(() => {
          this.loading = false;
        });
    }

    _initCardData() {
      this.savedCard = {};
      this.none = false;
      this.edit = false;

      this.loading = true;
      this._userData.getUserData()
        .then(res => {
          this.currentUser = res.user;
          this.noAddress = !res.user.user_info.shipping_details.street_1;
        })
        .then(() => this._customerService.getSavedPaymentMethod(this.currentUser.user_info.public_name))
        .then(res => {
          this.savedCard.last4 = res.last4;
          this.savedCard.id = res.customer_id;
        })
        .catch(error => {
          if (error.status === 400) {
            this.none = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

    _cardBin() {
      return this._cleanNum().substr(0, 6);
    }

    _cardLast4() {
      return this._cleanNum().substr(this._cleanNum().length - 4);
    }

    _cleanNum() {
      return this.card.cc_num.replace(/\s/g, '');
    }

    _initSelectOptions() {
      for (let i = 1; i < 13; i++) {
        this.monthRange.push({
          key: i,
          value: i
        });
      }

      let year = new Date().getFullYear();
      this.yearRange.push({
        key: year,
        value: year
      });
      for (let i = 1; i < 10; i++) {
        this.yearRange.push({
          key: year + i,
          value: year + i
        });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/my-account/payment-methods.ctrl.js